import axios from 'axios';
const EventBus = window.EventBus;

const REBATE_STRIP_MAX_REQUESTS = 4;
const rebateStripCache = new Map();
const rebateStripQueue = [];
let rebateStripActive = 0;
let rebateStripObserver = null;

function pumpRebateStrip() {
  while (rebateStripActive < REBATE_STRIP_MAX_REQUESTS && rebateStripQueue.length) {
    const card = rebateStripQueue.shift();
    if (card._isDestroyed) continue;
    rebateStripActive++;
    const done = () => {
      rebateStripActive--;
      pumpRebateStrip();
    };
    card.loadRebateStrip().then(done, done);
  }
}

function queueRebateStrip(card) {
  rebateStripQueue.push(card);
  pumpRebateStrip();
}

function observeRebateStrip(card, el) {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    queueRebateStrip(card);
    return;
  }
  if (!rebateStripObserver) {
    rebateStripObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const target = entry.target;
        rebateStripObserver.unobserve(target);
        const owner = target.__lbxRebateStripCard;
        target.__lbxRebateStripCard = null;
        if (owner) queueRebateStrip(owner);
      });
    }, { rootMargin: '600px 0px' });
  }
  el.__lbxRebateStripCard = card;
  rebateStripObserver.observe(el);
}

function unobserveRebateStrip(el) {
  if (!el) return;
  el.__lbxRebateStripCard = null;
  if (rebateStripObserver) rebateStripObserver.unobserve(el);
}

export const SpaVehicleCard = {
  props: ['vehicle', 'templatedir', 'lang','galleryinteraction', 'comingsoon', 'count', 'imagesForModels', 'gutembergOptions', 'cardCachebuster', 'useVin','similar', 'listingImage'],
  data(){
        return {
          picture: null,
          // These three used to call their getters right here, so instantiating
          // a card fired up to 3 GETs for the same ~33 KB per-vehicle JSON. On a
          // 300-card SRP that is 300-600 requests and ~10 MB retained before the
          // visitor has touched anything. They now stay empty until loadGallery()
          // runs on the first hover/touch of the card.
          secondPicture: 0,
          secondPictureWebp: 0,
          allPictures: 0,
          modelSelected: this.getImagesForModel(),
          discountsDetailsVisibility: false,
          discountsStatus: 'closed',
          msrpDisclaimerVisibility: false,
          msrpDisclaimerStatus: 'closed',
          discountsRebates: false,
          rebateStripOn: false,
          rebateStripCash: false,
          rebateStripRows: null,
          rebateStripRowsFor: null,
          specialDiscounts: 0,
          myCachebuster: this.cardCachebuster || false,
          useVinSlug: this.useVin || false,
          isSimilar: this.similar || false,
          selectedTab: 'cash',
          buyerDistanceKm: (typeof window !== 'undefined' && window.LBX_BUYER_DISTANCE_KM != null) ? window.LBX_BUYER_DISTANCE_KM : null,
          buyerPos: (typeof window !== 'undefined' && window.LBX_BUYER_POS) || null,
        }
  },
  mounted(){

    var lbxGeo = (typeof window !== 'undefined' && window.LBX_DEALER_LOCATION) || null;
    // City-only mode never geolocates the buyer — just shows the store city.
    if (lbxGeo && lbxGeo.srp && !lbxGeo.srpCityOnly && EventBus && typeof EventBus.initBuyerDistance === 'function') {
      EventBus.initBuyerDistance();
      EventBus.$on('lbx:buyer-distance', (km) => { this.buyerDistanceKm = km; });
      EventBus.$on('lbx:buyer-position', (pos) => { this.buyerPos = pos; });
    }

    // specialprice 0 significa "sin precio especial", no un precio de cero: sin
    // este guard el saleprice entero se convierte en descuento.
    if(this.vehicle.special && this.vehicle.specialprice > 0){
      if(this.vehicle.saleprice > this.vehicle.specialprice){
        this.specialDiscounts = this.vehicle.saleprice - this.vehicle.specialprice;
      }
    }

    if (this.vehicle.picture) {
      this.getFirstPicture(this.vehicle.picture, (result) => {
        this.picture = this.addCachebusterToken(result); // Asignar el valor de manera asíncrona
        this.seedGalleryWithMainPicture();
      });
    } else {
      this.picture = this.addCachebusterToken(this.templatedir); // Asignar el valor directamente si no hay asíncronía
      this.seedGalleryWithMainPicture();
    }

    this.attachGalleryTrigger();
    this.toggleGalleryHint(this.galleryinteraction == 'mini-gallery' && this.hasMorePictures());
    this.initRebateStrip();
  },
  created(){
    if(this.comingsoon == true && this.vehicle.incoming == true)
      this.templatedir = this.templatedir.split('-photo').join('-photo-incoming');
  },
  beforeDestroy(){
    this.detachGalleryTrigger();
    unobserveRebateStrip(this.rebateStripSlotEl());
    const queued = rebateStripQueue.indexOf(this);
    if (queued !== -1) rebateStripQueue.splice(queued, 1);
    // Release the cached response: while a card is mounted its detail JSON is
    // kept alive by the promise, and there is no reason to keep it after that.
    this.detailRequest = null;
  },
  methods: {
    goToVDP(viewSlug){
      window.location.href = viewSlug;
    },
    copyToClipboard(event,type) {
      try {
        if (event) {
          event.stopPropagation();
          if (event.target && event.target.innerHTML !== undefined) {
            var copyText = event.target.innerHTML;
            var textArea = document.createElement("textarea");
            textArea.value = copyText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("Copy");
            textArea.remove();

            if (type && type == 'vin') { 
              document.getElementById("lbx-vc-vin-custom-tooltip-"+this.vehicle.vin).style.display = "inline";
            }
            else if (type && type == 'stock') { 
              document.getElementById("lbx-vc-stock-custom-tooltip-"+this.vehicle.stocknumber).style.display = "inline";
            }

            setTimeout(() => {
              if (type && type == 'vin') { 
                document.getElementById("lbx-vc-vin-custom-tooltip-"+this.vehicle.vin).style.display = "none";
              }
              else if (type && type == 'stock') { 
                document.getElementById("lbx-vc-stock-custom-tooltip-"+this.vehicle.stocknumber).style.display = "none";
              }
            }, 2000);
          }
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    discountsDetailsOpen(event, withCashPrice){
      event.stopPropagation();
      this.discountsRebates = false;
      this.discountsDetailsVisibility = false;
      this.discountsDetailsVisibility = !this.discountsDetailsVisibility;
      this.discountsStatus = 'open';
      this.$nextTick(() => {
        this.getDiscountsInfo(this.vehicle.id, withCashPrice);
      });
    },
    discountsDetailsClose(event){
      event.stopPropagation();
      if (this.discountsStatus =='open'){
        this.discountsDetailsVisibility = false
        this.discountsStatus = 'closed'
      }
    },
    msrpDisclaimerOpen(event){
      event.stopPropagation();
      this.msrpDisclaimerVisibility = false;
      this.msrpDisclaimerVisibility = !this.msrpDisclaimerVisibility;
      this.msrpDisclaimerStatus = 'open';
    },
    msrpDisclaimerClose(event){
      event.stopPropagation();
      if (this.msrpDisclaimerStatus =='open'){
        this.msrpDisclaimerVisibility = false
        this.msrpDisclaimerStatus = 'closed'
      }
    },
    getDiscountsInfo(vehicleId, withCashPrice) {
      if(vehicleId && vehicleId != undefined){
          this.vehicleDetail()
          .then((data) => {
            if(!data) return;

            if(data.rebates && data.rebates.length > 0){
              // Only the rows that make up the price shown: additional and lease-only
              // rebates never do, cash-only ones just when the card shows the cash price.
              // filter() also copies: the response is shared, and the special-discount
              // push below would otherwise mutate it and stack a duplicate on every reopen.
              this.discountsRebates = data.rebates.filter((r) => !r.isadditional && !r.isleaseonly && (withCashPrice || !r.iscashonly));
            } else {
              this.discountsRebates = [];
            }

            if(data.special && data.specialprice > 0){
              if(data.saleprice > data.specialprice){
                this.discountsRebates.push({calculationtype: "special_discount", calculatedvalue: this.specialDiscounts});
              }
            }
          })
      }
    },
    rebateStripSlotEl() {
      const ref = this.$refs.rebateStripSlot;
      return Array.isArray(ref) ? ref[0] : ref;
    },
    initRebateStrip() {
      const slot = this.rebateStripSlotEl();
      if (!slot || !slot.getAttribute) return;

      this.rebateStripOn = true;
      this.rebateStripCash = slot.getAttribute('data-cash-price') === '1';

      const v = this.vehicle || {};
      if (!(Number(v.price) > 0 && Number(v.saleprice) > 0)) return;
      if (rebateStripCache.has(v.id)) {
        this.rebateStripRows = rebateStripCache.get(v.id);
        this.rebateStripRowsFor = v.id;
        return;
      }
      observeRebateStrip(this, slot);
    },
    loadRebateStrip() {
      const id = (this.vehicle || {}).id;
      return this.vehicleDetail().then((data) => {
        if (!data || this._isDestroyed) return;

        const rows = (Array.isArray(data.rebates) ? data.rebates : []).map((r) => ({
          name: String(r.name || '').replace(/\s+/g, ' ').trim(),
          value: Number(r.calculatedvalue) || 0,
          type: String(r.calculationtype || '').toLowerCase(),
          cash: !!r.iscashonly,
          lease: !!r.isleaseonly,
          additional: !!r.isadditional,
        }));
        rebateStripCache.set(id, rows);
        this.rebateStripRows = rows;
        this.rebateStripRowsFor = id;

        if (!this.galleryRequested) this.detailRequest = null;
      });
    },
    buildRebateStrip(rows, c) {
      const stack = [];
      const cashOnly = [];
      const adjustment = c.specialGap <= -1 ? -c.specialGap : 0;
      let increments = 0;
      let luxury = false;

      if (c.specialGap >= 1) stack.push({ dealer: true, amount: c.specialGap });

      if (rows) {
        rows.forEach((r) => {
          if (r.additional || !r.value) return;
          const amount = Math.round(Math.abs(r.value));
          if (r.lease) return;
          if (r.type === 'increment' || r.type === 'luxury tax') {
            increments += r.value;
            luxury = luxury || r.type === 'luxury tax';
          } else if (r.cash) {
            cashOnly.push({ name: r.name, label: r.name.replace(/^non-stackable\s+/i, ''), amount });
          } else {
            stack.push({ name: r.name, amount });
          }
        });
      } else {
        if (c.cashAmount < 0) cashOnly.push({ generic: true, amount: Math.round(-c.cashAmount) });
      }

      const included = c.withCash ? stack.concat(cashOnly) : stack.slice();
      const largest = included.reduce((best, row) => (!best || row.amount > best.amount ? row : best), null);
      const savings = included.reduce((total, row) => total + row.amount, 0);
      let charges;

      if (rows) {
        charges = Math.round(increments + adjustment);
        const drift = c.target - (savings - charges);
        if (Math.abs(drift) > 2) return false;
        if (drift && largest) largest.amount += drift;
        else if (drift) charges = Math.max(0, charges - drift);
      } else {
        charges = savings - c.target;
        if (charges < -2) return null;
        if (Math.abs(charges) <= 2 && adjustment < 1) {
          if (largest) largest.amount -= charges;
          charges = 0;
        }
      }

      const nonstack = c.withCash ? cashOnly : [];
      const infoCash = c.withCash ? [] : cashOnly;
      if (!stack.length && !nonstack.length && !charges && !infoCash.length) return null;
      const cashPrice = infoCash.length ? Math.round(c.price) - infoCash.reduce((total, row) => total + row.amount, 0) : 0;

      return {
        msrp: c.isNew && c.sale <= c.price ? Math.floor(c.sale) : 0,
        stack,
        nonstack,
        charges,
        chargesLuxury: !!rows && luxury,
        chargesAdjusted: adjustment >= 1,
        chargesNeutral: !rows && adjustment < 1,
        infoCash,
        cashPrice: cashPrice > 0 ? cashPrice : 0,
        hasExtras: infoCash.length > 0,
      };
    },
    toggleRebateStripClass(on) {
      if (!this.$el || !this.$el.classList) return;
      this.$el.classList.toggle('lbx-has-rebate-strip', on);
    },
    verifyRebateToTranslate(rebate) {
      const idiom = this.lang;
      
      if (idiom.includes('en')) {
        return rebate;
      }
    
      const lowerRebate = rebate.toLowerCase();
    
      if (lowerRebate.includes('delivery allowance')) {
        return 'Rabais à la livraison';
      }
    
      if (lowerRebate.includes('ev rebate retail')) {
        return 'Rabais gouvernement VE';
      }
    
      return rebate;
    },    
    showTooltip(type) {
      if(this.$refs[type] && this.$refs[type][0].classList){
        this.$refs[type][0].classList.remove('invisible');
        this.$refs[type][0].classList.add('visible');
        this.$refs[type][0].style.opacity = '100';
      }
    },
    hideTooltip(type) {
      if(this.$refs[type] && this.$refs[type][0].classList){
        this.$refs[type][0].classList.remove('visible');
        this.$refs[type][0].classList.add('invisible');
        this.$refs[type][0].style.opacity = '0';
      }
    },
    vehicleSlugPart(vin = false) {
      const parts = [
        this.vehicle.condition.toLowerCase().replace(/ /g, "-"),
        this.vehicle.year.toLowerCase().replace(/ /g, "-"),
        this.vehicle.make.toLowerCase().replace(/ /g, "-"),
        this.vehicle.model.toLowerCase().replace(/ /g, "-").replace('/', '')
      ];
    
      if (vin) {
        parts.push(this.vehicle.vin);
      }
    
      parts.push(this.vehicle.id);
    
      return parts.join("-");
    },
    trackEvent() {
      var data = this.vehicle.year + '-' +
      this.vehicle.make + '-' +
      this.vehicle.model + '-' +
      this.vehicle.trim + '-' +
      this.vehicle.stocknumber;

      var payload = {event_category: 'LBX-VDP', event_label: 'LBX-' + data};
      window.sendGAEvent('LBX-View-Click', payload);
    },
    getImagesForModel(){
      if(this.imagesForModels){
        let actualUrl = window.location.pathname.split("/");
        if(actualUrl.indexOf("model") >= 0){
            var modelS = actualUrl[actualUrl.indexOf("model")+1];
            var modelSelectedSplit = modelS.split(",");
                if(this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ] !== undefined)
                    return this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ];
                else
                    return null;
        }
        else if (this.gutembergOptions["model"] !== "all") {
          var model_name = this.gutembergOptions["model"]
          model_name = model_name.replace(/\s+/g, '-').toLowerCase();
          return this.imagesForModels[this.gutembergOptions["model"].toLowerCase()] || this.imagesForModels[model_name] ;
        }
        else
            return null;
    }else
        return null;

    },
    checkUrlExists(url) {
      url = url.replace("http:", "https:");
      return axios.head(url)
        .then(response => true) // URL válida
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return false; // URL no válida
          }
          return false; // Otro error
        });
    },
    toLeadboxImageUrl(src, size = '400-300') {
      if (!src) return null;

      if (src.includes('vehicleimages.leadboxhq.com')) {
        src = src.replace('http:', 'https:');

        // Feeds can hand us an already-sized CDN URL (e.g. -1080.jpg, ~120 KB)
        // for a ~340px card slot. Step it down to the requested width so every
        // card is not downloading and decoding a full-size photo. Never upscale.
        const qIndex = src.indexOf('?');
        const path = qIndex === -1 ? src : src.slice(0, qIndex);
        const query = qIndex === -1 ? '' : src.slice(qIndex);
        const parsed = this.parseLeadboxCdnSize(path);
        const w = parseInt(size, 10);

        if (parsed && w > 0 && w < parsed.w0) {
          const resized = parsed.h0 ? `${w}-${Math.round((parsed.h0 / parsed.w0) * w)}` : `${w}`;
          return `${parsed.base}-${resized}.${parsed.ext}${query}`;
        }
        return src;
      }
      const m = src.match(
        /https?:\/\/[^/]*blob\.core\.windows\.net\/([^/]+)\/vehicles\/([^/]+)\/pictures\/([a-f0-9-]+)(?:-[A-Z]+)?(?:\.\w+)?$/i
      );
      if (!m) return null;

      const dealer = m[1];
      const vehicleId = m[2];
      const imageId = m[3];

      return `https://vehicleimages.leadboxhq.com/v1/${dealer}/${vehicleId}/${imageId}-${size}.jpg`;
    },
    // Splits a size-parametric CDN path into {base, w0, h0, ext}, or null when it
    // carries no trustworthy -{w}[-{h}] suffix.
    parseLeadboxCdnSize(path) {
      let base = null;
      let w0 = null;
      let h0 = null;

      // Anchor the parse on the CDN layout — /v1/{dealer}/{vehicleId}/{uuid}-{w}[-{h}].{ext} —
      // with the 8-4-4-4-12 UUID spelled out. A greedy (.+) cannot tell the GUID from the
      // size suffix, so a UUID whose last block is all digits (…-9cb1-772148664503-400.jpg)
      // gets read as {w}=772148664503 / {h}=400, truncating the GUID and 404ing every rendition.
      const exact = path.match(
        /^(.*\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})-(\d+)(?:-(\d+))?\.(jpg|jpeg|png|webp)$/i
      );

      if (exact) {
        base = exact[1];
        w0 = parseInt(exact[2], 10);
        h0 = exact[3] ? parseInt(exact[3], 10) : null;
      } else {
        // Not UUID-named (future naming): keep the loose parse, but only trust a suffix
        // that reads like a real dimension — a digit-only name block would not.
        const crop = path.match(/^(.+)-(\d+)-(\d+)\.(jpg|jpeg|png|webp)$/i);
        const single = path.match(/^(.+)-(\d+)\.(jpg|jpeg|png|webp)$/i);

        if (crop && parseInt(crop[2], 10) <= 5000) {
          base = crop[1];
          w0 = parseInt(crop[2], 10);
          h0 = parseInt(crop[3], 10);
        } else if (single && parseInt(single[2], 10) <= 5000) {
          base = single[1];
          w0 = parseInt(single[2], 10);
        }
      }

      if (!base || !(w0 > 0)) return null;
      const ext = path.match(/\.(\w+)$/)[1];
      return { base, w0, h0, ext };
    },
    buildCardSrcset(url, ext = 'jpg') {
      if (!url || typeof url !== 'string') return null;

      const qIndex = url.indexOf('?');
      const path = qIndex === -1 ? url : url.slice(0, qIndex);
      const query = qIndex === -1 ? '' : url.slice(qIndex);

      // New CDN is size-parametric: swap the trailing -{w}(-{h}) suffix per
      // width so high-DPR screens can pick a larger rendition.
      if (path.includes('vehicleimages.leadboxhq.com')) {
        const parsed = this.parseLeadboxCdnSize(path);

        if (parsed) {
          return [400, 800, 1200].map((w) => {
            const size = parsed.h0 ? `${w}-${Math.round((parsed.h0 / parsed.w0) * w)}` : `${w}`;
            return `${parsed.base}-${size}.${ext}${query} ${w}w`;
          }).join(', ');
        }
      }

      // Legacy blob CDN / other sources: keep today's single candidate — the
      // named renditions (-gallery/-XXL) are not guaranteed to exist per dealer.
      return (ext === 'webp' ? path.replace('.jpg', '.webp') : path) + query;
    },
    buildCardSrcsetWebp(url) {
      return this.buildCardSrcset(url, 'webp');
    },
    cardSizes(width = 350) {
      return `(max-width: 640px) 100vw, ${width}px`;
    },
    getFirstPicture(vehiclePicture, callback) {
      const leadboxUrl = this.toLeadboxImageUrl(vehiclePicture, '400');
      if (leadboxUrl) {
        callback(leadboxUrl);
        return;
      }

      if (vehiclePicture && EventBus.checkValidCDN(vehiclePicture)) {
        this.checkUrlExists(vehiclePicture).then(status => {
          let result;
          if (status) {
            if (vehiclePicture.includes('XXL')) {
              result = vehiclePicture.split('XXL').join('card.jpg').replace('http:', 'https:');
            } else if (vehiclePicture.includes('.png') || vehiclePicture.includes('invassets')) {
              result = vehiclePicture.replace('http:', 'https:');
            } else {
              result = vehiclePicture.replace('http:', 'https:') + '-card.jpg';
            }
          } else {
            console.info('** --> URL not found: ', vehiclePicture);
            result = vehiclePicture.split('-XXL').join('').replace('http:', 'https:');
          }
          callback(result); // Devolver el resultado a través del callback
        }).catch(error => {
          console.error('Error checking URL:', error);
          callback((vehiclePicture || '').replace('http:', 'https:')); // En caso de error, devolver la URL modificada
        });
      } else {
        callback((vehiclePicture || '').replace('http:', 'https:').replace('.jpg-XXL', '.jpg')); // Si no hay vehiclePicture o no es válido
      }
    },
    getFirstPictureWebp(vehiclePicture){
      if(vehiclePicture && EventBus.checkValidCDN(vehiclePicture)){
        if(vehiclePicture.includes('XXL'))
          return vehiclePicture.split('XXL').join('card.webp').replace("http:","https:")
        else if(vehiclePicture.includes('.png') || vehiclePicture.includes('invassets'))
          return vehiclePicture.replace("http:","https:");
        else
          return vehiclePicture.replace("http:","https:")+"-card.webp";
      }
      else{
        return vehiclePicture.replace("http:","https:");
      }
    },
    // Single in-flight request for this vehicle's detail JSON. getAllPictures,
    // getSecondPicture, getSecondPictureWebp and getDiscountsInfo all read the
    // same ~33 KB file, and used to fetch it once each.
    vehicleDetail() {
      if (!this.detailRequest) {
        var urlDetail = window.location.origin + "/wp-content/uploads/data/" +
          this.vehicle.id + ".json?v=" + EventBus.getJSONTimestamp(5, 'Detail');

        this.detailRequest = axios.get(urlDetail)
          .then(({ data }) => data)
          .catch(() => {
            // A vehicle whose detail JSON has not been exported yet is not a
            // fatal case: the card keeps the main image inventory.json gave it.
            // Resolving to null instead of rejecting matters now that the
            // request is shared, otherwise a single 404 surfaces as an unhandled
            // rejection once per consumer.
            console.info('** --> Vehicle detail not found: ', urlDetail);
            return null;
          });
      }

      return this.detailRequest;
    },
    // numberofpics comes straight from inventory.json, so a card knows it has
    // more photos without fetching any of them.
    hasMorePictures() {
      return parseInt(this.vehicle.numberofpics, 10) > 1;
    },
    // Paints slick's arrows before the gallery exists, so a deferred card does
    // not read as a single-photo card. Handed over to the real slick arrows once
    // the pictures land. Targets .slick-gallery, which every card template that
    // renders a mini-gallery uses, child themes included.
    toggleGalleryHint(show) {
      if (!this.$el || !this.$el.querySelector) return;

      var gallery = this.$el.querySelector('.slick-gallery');
      if (!gallery) return;

      if (show)
        gallery.classList.add('lbx-gallery-hint');
      else
        gallery.classList.remove('lbx-gallery-hint');
    },
    // Is there anything behind an interaction at all? Most stores set no
    // gallery-interaction, and those cards should not carry listeners.
    needsGalleryFetch() {
      return this.galleryinteraction == 'mini-gallery'
        || this.galleryinteraction == 'swap-photo'
        || window.location.origin.includes("yorkdalelincoln");
    },
    // The trigger is wired here rather than in the blade on purpose: 31 child
    // themes ship their own copy of the vehicle-card template and share this
    // component, so a handler written into the parent's blade would silently
    // never run for any of them.
    attachGalleryTrigger() {
      if (!this.needsGalleryFetch()) return;
      if (!this.$el || !this.$el.addEventListener) return;

      // mouseover, not mouseenter: it bubbles, so it still fires on the child
      // themes whose card root is a display:contents wrapper with no box of its
      // own. Detaches itself on the first hit; loadGallery is idempotent anyway.
      this.galleryTrigger = () => {
        this.detachGalleryTrigger();
        this.loadGallery();
      };

      this.$el.addEventListener('mouseover', this.galleryTrigger);
      this.$el.addEventListener('touchstart', this.galleryTrigger, { passive: true });
      this.$el.addEventListener('load', this.markHoverImageLoaded, true);
    },
    detachGalleryTrigger() {
      if (!this.galleryTrigger || !this.$el || !this.$el.removeEventListener) return;

      this.$el.removeEventListener('mouseover', this.galleryTrigger);
      this.$el.removeEventListener('touchstart', this.galleryTrigger);
      this.galleryTrigger = null;
    },
    markHoverImageLoaded(event) {
      const hover = event.target && event.target.closest ? event.target.closest('.hoverImg') : null;
      if (hover) hover.classList.add('is-loaded');
    },
    // Fires on the first hover/touch anywhere on the card. The card's main image
    // never depended on any of this: it comes from vehicle.picture, which
    // inventory.json already carries.
    loadGallery() {
      if (this.galleryRequested) return;
      this.galleryRequested = true;

      // No mode checks here: each getter gates itself, so which interaction
      // wants what (including yorkdalelincoln's jpg-only hover swap) is decided
      // in exactly one place.
      this.getAllPictures(this.vehicle.id);
      this.getSecondPicture(this.vehicle.id);
      this.getSecondPictureWebp(this.vehicle.id);
    },
    // In mini-gallery mode the template renders allPictures, not picture, so
    // deferring the fetch would leave the card blank until hover. Seed it with
    // the main image so exactly one <img> renders up front and the other ten
    // slides only ever exist if the gallery is actually opened.
    seedGalleryWithMainPicture() {
      if (this.galleryinteraction != 'mini-gallery') return;
      if (this.galleryRequested) return;

      this.allPictures = [this.picture || this.templatedir];
    },
    getSecondPicture(vehicleId) {
        if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo') || window.location.origin.includes("yorkdalelincoln")){
        var finalUrl = "";

        this.vehicleDetail()
          .then((data) => {
            if(!data) return;
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];
              if(!finalUrl) return;

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPicture =finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPicture =  finalUrl.replace("http:","https:");
                else
                  this.secondPicture = finalUrl.replace("http:","https:")+"-card.jpg";
              }
              else{
                this.secondPicture = finalUrl.replace("http:","https:");
              }
            } else {
              finalUrl = this.templatedir;
              this.secondPicture = finalUrl;
            }
        });
    }
    return null;
    },
    getSecondPictureWebp(vehicleId) {
      if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo')){
        var finalUrl = "";

        this.vehicleDetail()
          .then((data) => {
            if(!data) return;
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];
              if(!finalUrl) return;

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPictureWebp =finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPictureWebp =  finalUrl.replace("http:","https:");
                else
                  this.secondPictureWebp = finalUrl.replace("http:","https:")+"-card.webp";
              }
              else{
                this.secondPictureWebp = finalUrl.replace("http:","https:");
              }
            }
        });
    }
    return null;
    },
    // The mode gate stays inside each getter, not only in loadGallery: 20+ child
    // themes call getAllPictures straight from a template binding, and without
    // the gate those stores would fetch the detail JSON even with no
    // gallery-interaction configured. Deferring is a bonus for templates that
    // leave the fetching to loadGallery; the ones that call in still behave
    // exactly as they do today.
    getAllPictures(vehicleId) {
      if(vehicleId && vehicleId != undefined  && (this.galleryinteraction != '' && this.galleryinteraction == 'mini-gallery')  ){
          this.vehicleDetail()
          .then((data) => {
            // Keep the seeded main picture rather than falling back to the
            // placeholder: a failed detail fetch says nothing about the image
            // inventory.json already handed us.
            if(!data) return;
            if(data.pictures && data.pictures.length > 0){
              // Slice before normalising: only the first 11 are ever rendered,
              // and a feed vehicle can carry 40+ pictures.
              var pictures = data.pictures.slice(0,11);

              for(var i= 0; i < pictures.length; i++){
                const leadboxUrl = this.toLeadboxImageUrl(pictures[i], '400');
                if (leadboxUrl) {
                  pictures[i] = leadboxUrl;
                } else if(pictures[i] && EventBus.checkValidCDN(pictures[i])){
                  if(pictures[i].includes('XXL'))
                    pictures[i] = pictures[i].split('XXL').join('card.jpg').replace("http:","https:");
                  else if(pictures[i].includes('.png') || pictures[i].includes('invassets') )
                    pictures[i] =  pictures[i].replace("http:","https:");
                  else
                    pictures[i] = pictures[i].replace("http:","https:")+"-card.jpg";
                }
                else{
                  pictures[i] = pictures[i].replace("http:","https:");
                }
              }

              // Assign first, then let slick claim the slides inside the same
              // flush. This used to be a setTimeout(100), which left the slides
              // stacked and unslicked for ~12 frames: the card grew by one photo
              // height per picture and every card below it reflowed, reading as a
              // page-wide flicker. $nextTick runs after Vue has patched the DOM
              // but before the browser paints, so there is no intermediate frame.
              this.allPictures = pictures;

              this.$nextTick(() => {
                      if(!data.trim)
                        var dtrim = "";
                      else
                        var dtrim = data.trim.split(' ').join('-');

                      jQuery(".slick-gallery-"+vehicleId).not(".slick-initialized").slick({dots:!0,
                        nextArrow: "<button data-vehicle='"+data.condition+'-'+data.year+'-'+data.make+'-'+data.model.split(' ').join('-')+'-'+dtrim+'-'+data.stocknumber+"' class='slick-next slick-arrow' aria-label='Next' type='button'>Next</button>",
                        infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,responsive:[{breakpoint:1279,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}}]});

                      // Drop the placeholder arrows only now that slick has
                      // drawn the real ones, so there is no frame without them.
                      this.toggleGalleryHint(false);
              });
            } else
                this.allPictures = [this.templatedir];

            // A manual lazy-loading pass used to run here against
            // ".vehicle-card .main-img". Cards render as ".content__vehicle-car",
            // so it matched nothing and only leaked an observer per card. The
            // templates already ship loading="lazy" with a real src.

          })
      }
    },
    trackEventForm(formType) {
      var payload = {event_category: 'LBX-Form', event_label: 'LBX-Form-' + formType};
      window.sendGAEvent('LBX-View', payload);
    },
    imgLoadOnError(id) {
      console.log("Error loading image: ", id);

      const imgs = (id && this.$refs[id + "vc-main-img"]) ? [].concat(this.$refs[id + "vc-main-img"]) : [];

      // A <picture> commits to the first matching <source>: if that rendition 404s the
      // <img> fires error even when its own src is a perfectly good photo. Drop the
      // sources and retry the plain src once before writing the photo off as missing.
      if (imgs.filter(img => this.retryPictureWithoutSources(img)).length) return;

      imgs.forEach(img => { img.src = this.templatedir; });
      this.picture = this.templatedir;
    },
    retryPictureWithoutSources(img) {
      if (!img || img.dataset.srcsetRetried) return false;

      const picture = img.parentNode;
      if (!picture || picture.tagName !== 'PICTURE' || !picture.querySelector('source')) return false;

      // Lazy layouts still hold the spinner in src while data-src carries the real photo.
      const src = img.getAttribute('data-src') || img.getAttribute('src');
      if (!src || src === this.templatedir) return false;

      img.dataset.srcsetRetried = '1';
      [].slice.call(picture.querySelectorAll('source')).forEach(source => source.remove());
      img.removeAttribute('src'); // re-run the browser's source selection, now sourceless
      img.src = src;
      return true;
    },
    FloorPlanLoadOnError(id) {
      if(this.$refs[id][0] && this.$refs[id][0].parentNode.parentNode) {
        this.$refs[id][0].parentNode.parentNode.remove();
      }
    },
    imgMiniGalleryLoadOnError(index, prefixLabel) {
      let prefix = (prefixLabel) ? prefixLabel : "mini_img_";
      this.$refs[prefix + index][0].src = this.templatedir;

      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.templatedir;

          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.templatedir;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.templatedir);
          }
        }
      }
    },
    imgLoadOnErrorSecondPicture(event) {
      // Same guard as the main photo: a 404 on a <source> rendition must not cost
      // us the good src the <img> is already carrying. Bound without parens, so the
      // handler gets the native event — no ref on the hover <img> to look up.
      if (this.retryPictureWithoutSources(event && event.target)) return;

      this.secondPicture = 0;
    },
    goToCompare(id) {
      EventBus.$emit('goToCompare', id, this.lang);
    },
    isMoreThan(value1, value2) {
      return value1 > value2
    },
    isMoreOrEqualThan(value1, value2) {
      return value1 >= value2
    },
    isLessOrEqualThan(value1, value2) {
      return value1 <= value2
    },
    isLessThan(value1, value2) {
      return value1 < value2
    },
    isTrue(value) {
      return value;
    },
    sumValue(value1, value2) {
      return value1 + value2
    },
    subtractValue(value1, value2) {
      return value1 - value2
    },
    getRebateSign(value, type) {
      return value > 0 ? ( (type.toLowerCase() == 'increment' || type.toLowerCase() == 'luxury tax') ? '+' : '-') : '';
    },
    // MSRP menos el precio que la card muestra (con o sin cash rebate, según
    // show-cash-price). Se deriva de los dos precios en pantalla en vez de
    // reensamblarse desde el feed: totaldiscounts ya trae dentro el descuento
    // especial, y sumarlo aparte lo contaba dos veces.
    totalDiscountShown(withCashPrice, exact) {
      const v = this.vehicle || {};
      const price = Number(v.price) || 0;
      if (price <= 0) return 0;
      const sale = Number(v.saleprice) || 0;
      const shown = price + (withCashPrice ? (Number(v.cashrebatesamount) || 0) : 0);
      const diff = exact ? sale - shown : Math.floor(sale) - Math.floor(shown);
      return diff > 0 ? diff : 0;
    },
    addCachebusterToken(url) {
      if (this.myCachebuster) {
          const currentHourTimestamp = Math.floor(Date.now() / 3600000);
          let storedTimestamp = localStorage.getItem('cachebusterTimestamp');

          if (!storedTimestamp || currentHourTimestamp !== parseInt(storedTimestamp, 10)) {
              storedTimestamp = currentHourTimestamp;
              localStorage.setItem('cachebusterTimestamp', storedTimestamp);
          }

          return `${url}?cb=${storedTimestamp}`;
      }
      return url; //* Si no está activado, devuelve la URL sin cambios
  },
  },
  computed: {
    // Espejo JS de lbx_trim_label(): el feed a veces repite el trim en
    // trimdescription y la card lo mostraba dos veces.
    trimDescriptionLabel() {
      const trim = String((this.vehicle && this.vehicle.trim) || '').trim();
      const desc = String((this.vehicle && this.vehicle.trimdescription) || '').trim();
      if (desc === '' || trim.toLowerCase() === desc.toLowerCase()) {
        return '';
      }
      if (trim !== '' && desc.toLowerCase().indexOf(trim.toLowerCase() + ' ') === 0) {
        return desc.slice(trim.length).trim();
      }
      return desc;
    },
    pictureSrcset() {
      return this.buildCardSrcset(this.picture);
    },
    pictureSrcsetWebp() {
      return this.buildCardSrcsetWebp(this.picture);
    },
    pictureSizes() {
      return this.cardSizes(350);
    },
    secondPictureSrcset() {
      return this.buildCardSrcset(this.secondPicture);
    },
    secondPictureSrcsetWebp() {
      return this.buildCardSrcsetWebp(this.secondPicture);
    },
    vehicleTitle(){
      if(this.lang == 'fr-CA')
        return (this.vehicle.condition ? `${this.$t(this.vehicle.condition)} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
      else
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
    },
    viewSlug(){
      let slug = "/view/";
      if(this.lang == 'fr-CA')
        slug = "/vue/";

      let useVinSlug  = this.useVinSlug ? this.useVinSlug : false;
      return slug + this.vehicleSlugPart(useVinSlug) + "/"
    },
    discount(){
      let result = this.vehicle.saleprice - this.vehicle.price;
      return ((result > 0 ) ? result : 0);
    },
    showMSRP(){
      let result = (this.vehicle.saleprice && this.vehicle.saleprice > 0 && this.vehicle.saleprice > this.vehicle.price);
      return result;
    },
    rebateStrip() {
      if (!this.rebateStripOn) return null;

      const v = this.vehicle || {};
      const price = Number(v.price) || 0;
      const sale = Number(v.saleprice) || 0;
      if (price <= 0 || sale <= 0) return null;

      const withCash = this.rebateStripCash;
      const cashAmount = Number(v.cashrebatesamount) || 0;
      const context = {
        sale,
        price,
        withCash,
        cashAmount,
        isNew: String(v.condition || '').toLowerCase() === 'new',
        target: Math.floor(sale) - Math.floor(price + (withCash ? cashAmount : 0)),
        specialGap: v.special && Number(v.specialprice) > 0 ? Math.floor(sale) - Math.floor(Number(v.specialprice)) : 0,
      };
      const rows = this.rebateStripRowsFor === v.id ? this.rebateStripRows : null;
      let strip = this.buildRebateStrip(rows, context);
      if (strip === false) strip = this.buildRebateStrip(null, context);
      return strip || null;
    },
    loadingTemplate() {
      return `
      <div role="status" class="flex justify-center items-center">
        <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path class="fill-current text-primary"
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="none" />
        </svg>
      </div>
      <span class="flex justify-center items-center font-primary-bold loading-text">${
        this.lang == "en-CA" ? "Loading" : "Chargement"
      }...</span>`;
    },
    // Location badge: the vehicle's city plus the buyer's straight-line distance
    // to it. When the vehicle's `location` (store name) has an entry in the
    // GENIUS['locations'] map (via window.LBX_DEALER_LOCATION.locations), the
    // badge uses that store's city/coords; otherwise it falls back to the
    // owning-site city/coords (single-location behaviour). Opt-in via the
    // vehicle-card "show-location-distance" option. No permission/coords =>
    // city only; no data at all => no badge.
    locationBadge() {
      var dealer = (typeof window !== 'undefined' && window.LBX_DEALER_LOCATION) || null;
      if (!dealer) return '';
      var entry = null;
      var storeName = this.vehicle && this.vehicle.location;
      if (dealer.locations && storeName && dealer.locations[storeName]) {
        entry = dealer.locations[storeName];
      }
      var city = entry ? (entry.city || dealer.city || '') : (dealer.city || '');
      var km = null;
      // City-only mode: never compute/show a distance, just the city.
      if (!dealer.srpCityOnly) {
        if (entry) {
          // A mapped store only shows a distance against its OWN coordinates —
          // never the owning site's, which could be a different city.
          if (this.buyerPos && entry.lat != null && entry.lng != null && EventBus && typeof EventBus.haversineKm === 'function') {
            km = Math.round(EventBus.haversineKm(this.buyerPos.lat, this.buyerPos.lng, entry.lat, entry.lng));
          }
        } else if (this.buyerDistanceKm != null) {
          km = this.buyerDistanceKm;
        }
      }
      if (km != null) {
        return city ? (city + ' (' + km + ' km)') : (km + ' km');
      }
      return city;
    },
  },
  watch: {
    rebateStrip(strip) {
      this.toggleRebateStripClass(!!strip);
    },
  },
  filters: {
    moneyFormat:(price, lang, digits = 0)=>{
      var formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
      });
      return ( digits != 0) ? formatter.format(price) : formatter.format(Math.floor(price));
    },
    mileageFormat:(mileage,lang)=>{

      const formatter = new Intl.NumberFormat(lang, {
        style: 'unit',
        unit: 'kilometer'
      });

     return formatter.format(Math.floor(mileage));
    },
    replaceLiter:(string)=>{
      if(string)
        return string.replace("Liter","L").replace("liter","L").replace("litre","L").replace("Litre","L");
      else
        return "-";

    },
    stringReplace:(value, search, rep)=>{
      let replacement = '';
      if (typeof rep !== 'undefined' && !rep) {
        replacement = rep;
      }

      if (typeof value === 'undefined' || value === null)
        return "";
      else
        return value.replace(search,replacement);
    }
  }
}
